export default __webpack_public_path__ + "static/tag-do-1-light-0788848ef4406ee8d7c8bcad4b2b773b.png";